/** Central scheduling URL — update here to change everywhere */
export const CALENDLY_URL = "https://calendly.com/techneed/intro";

/** Internal route for the scheduling page */
export const SCHEDULE_PATH = "/schedule";
